angular.module('leanlaw').controller('TrustDetailCtrl', ['$scope', '$rootScope', '$q', '$filter', '$timeout', '$window', '$state', '$stateParams', "alerts", 'userService', 'reportsService', 'leanLawApi', 'accountingService', "exportJson", "messageBus", "clientMatterManager", "singleRequest", function ($scope, $rootScope, $q, $filter, $timeout, $window, $state, $stateParams, alerts, userService, reportsService, leanLawApi, accountingService, exportJson, messageBus, ClientMatterManager, singleRequest) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.matter = null;
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.loading = true;
  $scope.trustAccount = null;
  $scope.print = function (withHeaders) {
    $scope.withHeaders = withHeaders;
    waitForDomThenPrint();
  };
  function waitForDomThenPrint() {
    $scope.printing = true;
    $scope.doneLoading = true;
    $timeout(() => {
      const element = $window.document.getElementById('done-loading');
      if (element && element.innerHTML === 'true') {
        $window.print();
        $scope.doneLoading = false;
        $scope.printing = false;
        $scope.withHeaders = false;
      } else {
        waitForDomThenPrint();
      }
    }, 200);
  }
  $scope.open = function (clientId, matterId) {
    $state.go('reports.originating-attorney-invoices', {
      accountId: $stateParams.id,
      clientId,
      matterId
    });
  };
  $scope.export = function () {
    // const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredTransactions.reduce((accum, t) => {
      const transaction = {
        Date: $filter("dateLogical")(t.date),
        Type: t.type,
        Balance: $filter("amount")(t.balance),
        Amount: $filter("amount")(t.amount),
        // puts description on 1 line so that the whole description is immediately visible in the .xlsl file
        Description: t.description.replace(/[\r\n]+/gm, " ")
      };
      accum.push(transaction);
      return accum;
    }, []);

    // adds the trust fund total at the end of the export file
    const total = {
      "Total Remaining Funds": $filter("amount")($scope.data.balance)
    };
    exp.push(total);
    exportJson.downloadCsv(exp);
  };
  $scope.return = function () {
    if ($stateParams.return) {
      $state.go($stateParams.return, $stateParams.backParams);
    }
  };
  activate();

  ///////////////////////////////////////

  async function activate() {
    let matter = null;
    let billing = null;
    if ($stateParams.matterId) {
      billing = await leanLawApi.getMatterBilling({
        id: $stateParams.matterId
      });
      matter = await ClientMatterManager.getMatter($stateParams.matterId);
      $scope.matter = matter;
      $scope.client = matter.client;
      if (matter.billing.trust) {
        $scope.trustAccount = matter.billing.trust.account.id;
      }
    } else {
      billing = await leanLawApi.getClientBilling({
        id: $stateParams.clientId
      });
      const client = await ClientMatterManager.getClient($stateParams.clientId);
      if (client) {
        $scope.client = client;
        if ($scope.client.billing.trust) {
          $scope.trustAccount = client.billing.trust.account.id;
        }
      }
    }
    if ($scope.trustAccount) {
      const status = await accountingService.verify(false);
      $scope.$apply();
      const address = billing.address.formatted.split("\n");
      $scope.address = {
        firm: `
                        <p><b>${status.companyName}</b><br/>
                        ${(status.companyAddress || '').replace(/\n/g, '<br/>')}
                        </p>`,
        client: `
                        <p>
                        <b>${address[0]}</b></br>
                        ${address.slice(1).join('<br/>')}
                        </p>
                        <p></p>`,
        matter: $stateParams.matterId && `<p>Re: ${matter.label}</p>`
      };
      singleRequest.apiCall("transactions").getAccountingAccount({
        id: $scope.trustAccount,
        transactions: true
      }).then(data => {
        if (!data) return;
        if (data) {
          $scope.loading = false;
        }
        $scope.data = data;
        $scope.transactions = $scope.data.transactions;
        $scope.data.transactions = getRunningBalance($scope.transactions);
      }).catch(err => {
        alerts.error(err);
      });
      const deactivate = $rootScope.$on('$stateChangeStart', () => {
        singleRequest.cancel("transactions");
        deactivate();
      });
    } else {
      $scope.loading = false;
      alerts.error("Client/Matter doesn't have an associated trust account");
      $state.go("reports.trust", {
        return: "reports.trust",
        report: `Trust Report`
      });
    }
    // picks up client/matter change from client/matter picker if needed
    $scope.$on("report-clientmatter-change", (event, cm) => {});

    // handles matter checkbox
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });
  }
  function getRunningBalance(transactions) {
    $scope.sortedData = $filter('orderBy')(transactions, 'date', false);
    let balanceTracker = 0;
    $scope.sortedData.forEach(item => {
      balanceTracker += item.amount;
      item.balance = balanceTracker;
    });
    return $scope.sortedData;
  }

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredTransactions = $filter('orderBy')($filter('filter')($scope.data.transactions, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.transactions', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);